import { render, staticRenderFns } from "./TeacherLeaveApproval.vue?vue&type=template&id=36411fe6&scoped=true&"
import script from "./TeacherLeaveApproval.vue?vue&type=script&lang=js&"
export * from "./TeacherLeaveApproval.vue?vue&type=script&lang=js&"
import style0 from "./TeacherLeaveApproval.vue?vue&type=style&index=0&id=36411fe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36411fe6",
  null
  
)

export default component.exports